(function () {
    var SELECTOR_ROOT = '.paywhirl-plan-selector';
    var observer = null;
    var bootstrap = null;
    var giveUp = null;

    /* :has() is unavailable on older browsers (pre-2022 Chrome / Samsung
       Internet), where the CSS-only selected state and reveals never fire.
       Mirror the checked radio into a .pw-checked class; paywhirl-custom.css
       carries class twins of every :has() rule. */
    function syncCheckedClass() {
        var groups = document.querySelectorAll('.paywhirl-plan-selector-group');
        for (var i = 0; i < groups.length; i++) {
            var input = groups[i].querySelector('input[type="radio"]');
            groups[i].classList.toggle('pw-checked', !!(input && input.checked));
        }
    }

    function applyPaywhirlSubscriptionDetails() {
        syncCheckedClass();

        const subscriptionGroup = document.querySelector(
        '.paywhirl-plan-selector-group:nth-of-type(2)'
        );

        if (!subscriptionGroup) return;

        const planContainer = subscriptionGroup.querySelector(
        '.paywhirl-plan-selector-plan'
        );

        if (!planContainer) return;

        let detailsBlock = subscriptionGroup.querySelector(
        '.paywhirl-subscription-details'
        );

        if (!detailsBlock) {
        detailsBlock = document.createElement('div');
        detailsBlock.className = 'paywhirl-subscription-details is-initial';
        detailsBlock.innerHTML = `
            <ul class="paywhirl-subscription-benefits">
            <li>Save 15% every time - never run out</li>
            <li>No commitment — cancel anytime</li>
            <li>Free delivery on 3+ bottles</li>
            <li>Only need 1 product? Order 3 every 90 days - free delivery</li>
            </ul>
        `;

        planContainer.insertAdjacentElement('afterend', detailsBlock);
        }

        /* Let the block paint in its final state, then re-enable the
        transition so later plan switches still animate. */
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                detailsBlock.classList.remove('is-initial');
            });
        });
    }

    /* Steady state: watch only the PayWhirl selector. It re-renders when the
       plan or frequency changes, which is the only case the injected block
       needs to survive. */
    function watch(target) {
        if (observer) observer.disconnect();
        observer = new MutationObserver(applyPaywhirlSubscriptionDetails);
        observer.observe(target, { childList: true, subtree: true });
    }

    function stopBootstrap() {
        if (bootstrap) {
            bootstrap.disconnect();
            bootstrap = null;
        }
        if (giveUp) {
            clearTimeout(giveUp);
            giveUp = null;
        }
    }

    /* Inject at the earliest possible moment, then narrow. The bootstrap
       observer runs the full attempt on every mutation rather than waiting for
       a container to appear, so the block goes in on the first paint where the
       target exists. */
    function attempt() {
        applyPaywhirlSubscriptionDetails();

        if (!document.querySelector('.paywhirl-subscription-details')) return;

        stopBootstrap();

        var root = document.querySelector(SELECTOR_ROOT);
        if (root) {
            watch(root);
        }
    }

    /* Radio checks change no DOM the observers can see, so the class sync
       needs its own listener. Delegated so it survives PayWhirl re-renders. */
    document.addEventListener('change', function (e) {
        if (!e.target || !e.target.closest) return;
        if (!e.target.closest('.paywhirl-plan-selector-group')) return;
        syncCheckedClass();
    });

    attempt();

    if (!document.querySelector('.paywhirl-subscription-details')) {
        bootstrap = new MutationObserver(attempt);
        bootstrap.observe(document.documentElement, {
            childList: true,
            subtree: true
        });

        /* On pages with no PayWhirl at all, stop watching rather than observe
           the document for the life of the page. */
        giveUp = setTimeout(stopBootstrap, 15000);
    }
})();